// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__0Hitp","desabilitar":"OptionSelect_desabilitar__LhLtP","focado":"OptionSelect_focado__NGb7j","novo":"OptionSelect_novo__9qPn7"};